module.exports = __webpack_public_path__ + "static/media/thank-you.590ebb86.png";